export default {"src":"/_next/static/media/banner-devider.ece5d613.svg","height":510,"width":84,"blurWidth":0,"blurHeight":0};